'use strict';

var ProductReveal = /** @class */ (function () {
    function ProductReveal(wrapper) {
        this.init();
    }
    /** Init **/
    ProductReveal.prototype.init = function () {
        this.initCarousel();
        this.addEvents();
    };

    ProductReveal.prototype.initCarousel = function () {
        $(".o-products .owl-carousel").each(function (index, item) {
            var responsive = {
                0: {
                    items: 1,
                },
                450: {
                    items: 2,
                },
                800: {
                    items: 3,
                },
                1200: {
                    items: 4,
                    nav: true,
                }
            }

            $(item).owlCarousel({
                items: 1,
                stagePadding: 30,
                loop: true,
                margin: 10,
                nav: true,
                navText: ['4', '5'],
                dots: true,
                mouseDrag: true,
                touchDrag: true,
                responsive: responsive
            });

        });
    };

    /** End Init **/

    /** Events **/
    ProductReveal.prototype.addEvents = function () {
        var self = this;

        $('.add-product-from-carousel .a-button__span').unbind('click').bind("click", function (e) {
            e.preventDefault();
            var $this = $(e.currentTarget);
            var $parentButton = $this.parent('.add-product-from-carousel');
            var itemRef = $parentButton.data('itemref');
            var data = { "itemRef": $parentButton.attr('data-itemRef'), "target": $parentButton  }

            if (itemRef !== undefined && !$parentButton.hasClass("-added")) {
                self.addProductFromMerchandisingAreas(data);
            }
        });

    };
    /** End Events **/

    /* AJAX Functions */
    ProductReveal.prototype.addProductFromMerchandisingAreas = function (data) {
        $.ajax(
            {
                url: '/CartResume/AddItemFromPopinProductMerchAreas',
                contentType: "application/json",
                data: {
                    reference: data.itemRef
                },
                beforeSend: function (e) {
                    Foundation.libs.common.showPreloader();
                },
                success: function (result) {
                    if (result.IsValid == true) {
                        Foundation.libs.common.clearLightCart();
                        data.target.toggleClass('-added');

                        setTimeout(function () {
                            data.target.removeClass("-added");
                        }, 3000);

                        Foundation.libs.common.hidePreloader();


                        Foundation.libs.common.refreshMasterTagData(result._MasterTagJson, true);
                        Foundation.libs.common.refreshMasterTag();

                        if (typeof (tc_vars) !== "undefined" && typeof (tc_vars.order_products) !== "undefined") {
                            var order_product = tc_vars.order_products.filter(function (p) {
                                return p.product_id === data.itemRef;
                            })[0];

                            if (typeof (order_product) !== "undefined") {
                                $(document).foundation('mastertag', 'trackAddToCart', { trigger: 'ajout_panier', category: 'modal' });
                            }
                        }
                    }
                    else {
                        if (result.UrlFicheProduit != null) {
                            window.location.href = result.UrlFicheProduit;
                        }
                    }
                }
            }
        ).fail(function (result) {
            Foundation.libs.common.hidePreloader();
        });
        }

    /* End AJAX Functions */

    return ProductReveal;
}());